import React from 'react'



function Button({className, children, onClick, showImage=true}) {
    return (
        <button className={`button ${className}`} onClick={onClick} >
            {children}
            {showImage?(
                <img src="/wp-content/themes/tradewater/dist/widget/images/arrow-btn.svg" alt="arrow"/>
            ):null}
        </button>
    )
}

export default Button